import {
  Avatar, Button, Card, CardActions, CardContent, CardMedia, Stack, Typography
} from "@material-ui/core";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import IdealCard from "../../components/IdealCard";
import seen_pic from "../../img/seen.svg";
import vote_pic from "../../img/vote.svg";
import {
  getTeamList,
  updateViewerCount,
  vote
} from "../../services/IdealPoolService";
import { updatecurrentPlanIndex } from "../../services/MilestoneService";
import { teamList } from "../../services/TeamService";
import { RootStoreContext } from "./../../store";
import { planList } from "./constant";
import {
  Action,
  ActionContainer,
  ActivityButton,
  // Card,
  Container,
  Description,
  Gap,
  IdealBorder,
  IdealBorderImg,
  IdealBorderNum,
  Names,
  OuterCard,
  ProgressBar,
  ProgressBarContainer,
  ProgressContainer,
  ProgressText,
  SmallNames,
  SmallText,
  StartButton,
  Step,
  SubTitle,
  Title,
  TopicTitle,
  Upper,
  YellowText
} from "./style";
import "./style.css";

const IdealPool = () => {
  const { LoginStore } = useContext(RootStoreContext);
  const { user, login, updateData } = LoginStore;
  const [isUser, setIsUser] = useState(false);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 3000);
  }, []);
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        setIsUser(true);
        updateData("user", user);
        updateData("login", true);
      } else {
        setIsUser(false);
        updateData("login", false);
      }
    });
  });
  useEffect(() => {
    getTeamList()
      .then((value) => {
        setTeams(value);
        console.log(value);
      })
      .catch(console.log);
  }, []);
  if (loading) return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <BeatLoader loading={loading} />
        <p>Loading...</p>
      </div>
    </div>
  );
  return (
    <div>
      <Container>
        <Step>
          <YellowText>Final</YellowText>
          <Gap />
          <SmallText>創業點子池</SmallText>
        </Step>
        <Title>歷屆商業計畫</Title>
        {isUser ? (
          <SubTitle>
            這邊是點子池，同學們可以點擊標題進入查看其他創業團隊的點子～大家可以幫你喜歡的點子投票喔！
          </SubTitle>
        ) : (
          <SubTitle>
            這邊是點子池，同學們可以點擊標題進入查看其他創業團隊的點子～登入之後即可創造自己的點字並且為喜歡的點子投票喔！
          </SubTitle>
        )}
        <Stack justifyContent="flex-start" direction="row" sx={{ flexWrap: "wrap", marginTop: "5vw" }}>
          {teams.map((item, index) => {
            return (
              <IdealCard teamName={item.teamname} members={item.members} description={item.ideation} vote={item.likes} seen={item.ViewerCount} />
            );
          })}
          {/*{teams.map((item, index) => {
            // console.log(item);
            if (item.teamname !== "")
              return (
                <Card className="box">
                  <Upper>
                    <a
                      href={item.companyUrl}
                      onClick={() => {
                        // console.log(item.id);
                        updateViewerCount(item.id);
                      }}
                    >
                      <TopicTitle>{item.teamname}</TopicTitle>
                      <Gap />
                      <Gap />
                      <Names>
                        成員：
                        {item.members.map((i, idx) => {
                          return <SmallNames>{i.name}&nbsp;</SmallNames>;
                        })}
                      </Names>
                      {item.ideation && (
                        <div>
                          <Description>團隊介紹：</Description>
                          <Description className="text">
                            {item.ideation}
                          </Description>
                        </div>
                      )}
                      <Gap />
                      <Gap />
                    </a>
                  </Upper>
                  <IdealBorder>
                    {isUser ? (
                      <ActivityButton
                        onClick={() => {
                          if (item.likeBy.includes(user.id))
                            window.alert("不可重複投票。");
                          else if (window.confirm(`確定投票給${item.teamname}`))
                            vote(item.id);
                        }}
                      >
                        投一票
                      </ActivityButton>
                    ) : (
                      <StartButton onClick={() => alert("請登入投票！")}>
                        投一票
                      </StartButton>
                    )}
                    <IdealBorderImg src={vote_pic}></IdealBorderImg>
                    {item.likes ? (
                      <IdealBorderNum>&nbsp;{item.likes}</IdealBorderNum>
                    ) : (
                      <IdealBorderNum>&nbsp;0</IdealBorderNum>
                    )}
                    <IdealBorderImg src={seen_pic}></IdealBorderImg>
                    {item.ViewerCount ? (
                      <IdealBorderNum>&nbsp;{item.ViewerCount}</IdealBorderNum>
                    ) : (
                      <IdealBorderNum>&nbsp;0</IdealBorderNum>
                    )}
                  </IdealBorder>
                </Card>
              );
          })}*/}
        </Stack>
      </Container>
    </div>
  );
};

export default observer(IdealPool);
